export * from './context-permissions.component';
export * from './context-permissions-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/context/context-permissions/index.ts